// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

import {
  SESSION_INIT,
  SESSION_LOGIN, SESSION_LOGIN_SUCCESS, SESSION_LOGIN_FAILURE,
  SESSION_RESET_PASSWORD, SESSION_RESET_PASSWORD_SUCCESS,
  SESSION_LOGOUT, SAVE_USER_DATA, REGISTRATION_STATUS, INITIALIZE_STRIPE, DISPLAY_PASSWORD_RESET_DAILOG, PASSWORD_RESET_STATUS
} from '../actions/actions';

const initialState = {
  enableAutoPlay: false,
  error: undefined,
  passwordReset: false, // TODO: should come from the server
  publishRoute: false,
  role: undefined,
  state: 'initial', // initial | changing | ready
  token: undefined,
  userName: undefined,
  registrationStatus : undefined,
  registrationMessage : undefined,
  stripeAPIKey : "",
  resetPassword: false,
  passwordResetStatus: '',

};



const stateForLogin = (action) => ({
  userName: action.userName,
  role: action.role,
  home: homeForRole(action.role),
  token: action.token,
  needPasswordReset: action.needPasswordReset,
  publishRoute: 'Gru' === action.userName,
  enableAutoPlay: (action.userName &&
    'u' === action.userName[action.userName.length - 1])
});

const handlers = {
  [SESSION_INIT]: (_, action) => stateForLogin(action),

  [SESSION_LOGIN]: (_, action) => ({
    state: 'changing',
    userName: action.userName
  }),

  [SESSION_LOGIN_SUCCESS]: (_, action) => ({
    ...stateForLogin(action),
    state: 'ready',
    error: undefined
  }),

  [SESSION_LOGIN_FAILURE]: (_, action) => ({
    state: 'initial',
    error: action.error
  }),

  [SESSION_RESET_PASSWORD]: (_, action) => ({
    state: 'changing',
    error: undefined
  }),

  [SESSION_RESET_PASSWORD_SUCCESS]: (_, action) => ({
    state: 'ready',
    needPasswordReset: false
  }),

  [SESSION_LOGOUT]: () => ({
    state: 'initial',
    userName: null,
    token: undefined
  }),

  [REGISTRATION_STATUS]:(state, action) => ({
    registrationStatus: action.result.status,
    registrationMessage : action.result.message
  }),

  [INITIALIZE_STRIPE] : (state, action) => ({
    stripeAPIKey: action.result.stripeAPIKey
  }),

  [DISPLAY_PASSWORD_RESET_DAILOG] : (state, action) => ({
    resetPassword : action.result
  }),

  [PASSWORD_RESET_STATUS]: (state, action) => ({
    passwordResetStatus : action.result
  })
};

export default function sessionReducer(state = initialState, action) {
  let handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
}



// WEBPACK FOOTER //
// ./src/js/reducers/session.js